/**
 * Normalizes list API payloads into rows + total for server-side pagination.
 * Supports direct responses and one-level gateway nesting.
 */
export function parseListResponse(payload) {
  if (!payload) {
    return { rows: [], total: 0 };
  }

  const nested =
    payload.data &&
    typeof payload.data === 'object' &&
    !Array.isArray(payload.data) &&
    (Array.isArray(payload.data.data) || payload.data.total_elements !== undefined);

  const body = nested ? payload.data : payload;
  const rows = Array.isArray(body?.data) ? body.data : Array.isArray(body) ? body : [];
  const rawTotal = body?.total_elements ?? body?.totalElements ?? body?.total;
  const total = rawTotal === undefined || rawTotal === null ? 0 : Number(rawTotal);

  return {
    rows,
    total: Number.isFinite(total) ? total : 0,
  };
}
